import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Input, Form, FormGroup, Label, Alert, Row, Col } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'

export default function PlaintiffSearchForm({ location, largeChoice, plaintiffSearchCallback }) {
  console.log('PlaintiffSearchForm rendered', location)

  let initialInputs = {
    lastName: '',
    firstName: '',
    ssn: '',
    scsNumber: ''
  }
  if (location) {
    // previous inputs
    const params = new URLSearchParams(location.search)
    initialInputs = JSON.parse(params.get('inputs'))
  }

  const navigate = useNavigate()
  const { inputs, handleInputChange, handleSubmit } = useForm(initialInputs, submitSearch, enterKeyHandler(submitSearch))
  const [formFeedback, setFormFeedback] = useState()

  async function submitSearch() {
    console.log('PlaintiffSearchForm.submitSearch', inputs)
    let validInput = false
    for (let input in inputs) {
      if (inputs[input]) {
        validInput = true
      }
    }

    if (!validInput) {
      return setFormFeedback(<Alert className='custom-alert' color='danger' style={{display: 'block'}}>At least one search parameter must be used.</Alert>)
    }

    const url = `/custom/fwinvoice.plaintiff_selection?inputs=${JSON.stringify(inputs)}`
    if (largeChoice) {
      plaintiffSearchCallback(url)
    } else {
      navigate(url)
    }
  }

  return (
    <div style={{ textAlign: 'center'}}>
      <div style={{ display: 'inline-block', margin: '10px auto' }}>
        {formFeedback}
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col>
              <FormGroup>
                <Label style={{ float: 'left'}}><b>Last Name</b></Label>
                <Input name='lastName' defaultValue={inputs.lastName} onChange={handleInputChange} />
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <Label style={{ float: 'left'}}><b>First Name</b></Label>
                <Input name='firstName' defaultValue={inputs.firstName} onChange={handleInputChange} />
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <Label style={{ float: 'left'}}><b>SSN</b></Label>
                <Input name='ssn' defaultValue={inputs.ssn} onChange={handleInputChange} />
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <Label style={{ float: 'left'}}><b>SCS Number</b></Label>
                <Input name='scsNumber' defaultValue={inputs.scsNumber} onChange={handleInputChange} />
              </FormGroup>
            </Col>
            <Col style={{ marginTop: '27px'}}>
              <Button className='plaintiff-search-button' color="primary">Search</Button>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  )
}